<template>
  <div>
    <!-- 面包屑导航 -->

    <el-card style="min-height: 600px;width: 98%;">
      <el-form :model="userInfo" :inline="true" label-width="100px" style="margin-top: 10px;">
        <el-col :span="12">
          <el-form-item label="用户名" label-width="150px">
            <el-input    v-model="userInfo.name" placeholder="请输入用户名" style="width: 100%;"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机号" label-width="150px">
            <el-input  v-model="userInfo.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="密码" label-width="150px">
            <el-input  v-model="userInfo.password" type="password" placeholder="请输入密码"></el-input>
          </el-form-item>
        </el-col>

      <el-button type="primary" @click="save()" v-if="!state"  icon="el-icon-check"
					style="margin-left: 31%;width:300px">提交
				</el-button>
      </el-form>

    </el-card>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        userInfo: {
          name:"",
          userId: localStorage.getItem('userId'),
          phone:localStorage.getItem("phone"),
          unitCode:"410800000000",
          password:"",

        },
        state:false,

      };
    },
    created() {
      this.getData();
    },
    methods: {
    async getData() {
          const {
            data: res
          } = await this.$http.get("/web/queryByUserId/" + this.userInfo.userId);
        this.userInfo=res.data;
      },
      save() {
        this.$http.post('/web/updateWebUser', this.userInfo).then((res) => {
          this.$message({
            showClose: true,
            message: '信息修改成功',
            type: 'success'
          });
        })

      },


    }

  };
</script>

<style lang="scss" scoped>
  .select {
    width: 210px;
    height: 40px;
    border-color: #dcdfe6;
  }

  .selectAdd {
    width: 194px;
    height: 40px;
    border-color: #dcdfe6;
  }
</style>
